import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [dealer, setDealer] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("dealer_token");
    if (!token) { setChecking(false); return; }
    api.get("/auth/me")
      .then((r) => setDealer(r.data))
      .catch(() => localStorage.removeItem("dealer_token"))
      .finally(() => setChecking(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("dealer_token", r.data.token);
    setDealer({ ...r.data.user });
    return r.data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("dealer_token");
    setDealer(null);
  }, []);

  return (
    <AuthContext.Provider value={{ dealer, checking, login, logout, setDealer }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
